import { useState } from "react";
import { formatAddress } from "../../utils";
import OverViewItemCard from "../OverViewItemCard";
import { MoneyIcon, WalletIcon, LockIcon, ActivityIcon, CalendarIcon, ArrowDownIcon, PiggyBankIcon, CopyIcon } from "../SVGIcons";
import { useTheme } from "../../context/ThemeContext";
import { RadiusBorder } from "../RadiusBorder";

const DepositorDetailOverview: React.FC<{
  id: string;
  depositorsListData: any;
  balance: string;
}> = ({ id, depositorsListData, balance }) => {
  const [copied, setCopied] = useState(false);
  const { theme } = useTheme();

  const handleCopyAddress = async () => {
    if (!id) return;
    try {
      await navigator.clipboard.writeText(id);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy address:', err);
    }
  };

  return (
    <div className="">
      <h2 className="text-xl font-semibold text-black dark:text-white mb-4">Overview</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="relative h-[119px]">

          <div className="relative bg-transparent rounded-[24px] h-full w-full p-6 flex flex-col justify-between overflow-visible z-20">
            <RadiusBorder />
            <div className="absolute top-0 right-0 z-30">
              <div className={`bg-${theme === 'dark' ? "[#262626]" : "[#F2F2F2]"} w-10 h-10 flex items-center justify-center rounded-full`}>
                <WalletIcon fillColor={theme === 'dark' ? '#fff' : '#000'} />
              </div>
            </div>
            <p className={`text-sm ${theme === 'dark' ? 'text-white/70' : 'text-black/70'} font-borna`}>Address</p>
            <div className="flex items-center gap-2">
              <p className={`text-3xl font-borna leading-none ${theme === 'dark' ? 'text-white' : 'text-black'}`}>{formatAddress(depositorsListData.address || '')}</p>
              <button
                onClick={handleCopyAddress}
                className="p-1 hover:bg-gray-100 dark:hover:bg-gray-800 rounded transition-colors"
                title="Copy address"
              >
                {copied ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                ) : (
                  <CopyIcon fillColor={theme === 'dark' ? '#fff' : '#000'} className="w-[20px] h-[20px]" />
                )}
              </button>
            </div>
          </div>
        </div>
        <OverViewItemCard
          cardView={<MoneyIcon fillColor={theme === 'dark' ? '#fff' : '#000'} />}
          value={balance ? 'τ' + (Number(balance.replace(/,/g, ''))).toFixed(3) : 'Unknown'}
          title="Balance"
          iconColor={theme === 'dark' ? "bg-[#262626]" : "bg-[#F2F2F2]"}
          textColor={theme === 'dark' ? "text-white" : "text-black"}
          extClsName="!items-start"
        />

        <OverViewItemCard
          cardView={<ArrowDownIcon fillColor={theme === 'dark' ? '#fff' : '#000'} />}
          value={`τ${depositorsListData.totalDeposits.toFixed(3)}`}
          title="Total Deposits" iconColor={theme === 'dark' ? "bg-[#262626]" : "bg-[#F2F2F2]"}
          textColor={theme === 'dark' ? "text-white" : "text-black"}
          extClsName="!items-start"
        />

        <OverViewItemCard
          cardView={<ActivityIcon fillColor={theme === 'dark' ? '#fff' : '#000'} />}
          value={`${(depositorsListData.depositPercentage).toFixed(3)}%`}
          title="Deposit Percentage" iconColor={theme === 'dark' ? "bg-[#262626]" : "bg-[#F2F2F2]"}
          textColor={theme === 'dark' ? "text-white" : "text-black"}
          extClsName="!items-start"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
        <OverViewItemCard cardView={<PiggyBankIcon fillColor={theme === 'dark' ? '#fff' : '#000'} />} value={`τ${depositorsListData.availableAmount.toFixed(3)}`} title="Available Amount" iconColor={theme === 'dark' ? "bg-[#262626]" : "bg-[#F2F2F2]"} textColor={theme === 'dark' ? "text-white" : "text-black"} />
        <OverViewItemCard cardView={<LockIcon fillColor={theme === 'dark' ? '#fff' : '#000'} />} value={`τ${depositorsListData.lockedAmount.toFixed(3)}`} title="Locked Amount" iconColor={theme === 'dark' ? "bg-[#262626]" : "bg-[#F2F2F2]"} textColor={theme === 'dark' ? "text-white" : "text-black"} />
        <OverViewItemCard cardView={<CalendarIcon fillColor={theme === 'dark' ? '#fff' : '#000'} />} value={depositorsListData.joinDate} title="Join Date" iconColor={theme === 'dark' ? "bg-[#262626]" : "bg-[#F2F2F2]"} textColor={theme === 'dark' ? "text-white" : "text-black"} extClsName="md:col-span-2" />
      </div>
    </div>
  )
}

export default DepositorDetailOverview;